export { default } from "./LabelWithBadge";
